'use client'
import Button from '@/components/atoms/Button'

interface ButtonWithAnchorProps extends React.ComponentProps<typeof Button> {
  anchorID?: string
  onAnchorClick?: () => void
}

const ButtonWithAnchor = ({
  anchorID,
  onAnchorClick,
  ...rest
}: ButtonWithAnchorProps) => {
  const onClick = () => {
    if (!anchorID) return
    const htmlEl = document.querySelector(`#${anchorID}`)

    if (!htmlEl) return
    if (onAnchorClick) {
      setTimeout(() => {
        onAnchorClick()
      }, 1000)
    }

    const rect = htmlEl.getBoundingClientRect()
    const top = rect.top + window.scrollY - 200

    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }

  return (
    <Button
      {...rest}
      onClick={onClick}
    />
  )
}

export default ButtonWithAnchor
